import { FC, ReactNode } from 'react';
import { createPortal } from 'react-dom';

type Props = {
  children: ReactNode;
  domNode: Element;
};

/**
 * Wrapper which uses `ReactDOM.createPortal()` function.
 *
 * Wrap any component into `Portal` and it will be rendered as child node of `domNode`.
 *
 * [See React Portals documentation for more info](https://reactjs.org/docs/portals.html)
 *
 * @tags gadget, portal, DOM
 */
export const Portal: FC<Props> = props => createPortal(props.children, props.domNode);
